<template>
    <ion-toolbar>
        <ion-buttons
            slot="start"
            v-if="$store.state.pages.auth.back.length || stepLanguage || routeName == 'profile_languages'">
            <ion-button class="button_back" v-if="routeName==='profile_languages'" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end" v-if="routeName != 'profile_languages'">
            <ion-button class="pill next-pill-button" @click="skip">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <PageTitle title="Languages" subtitle="Please select the languages you know" showIcon/>
            <el-form
                class="full_page"
                :model="formsData.userForm"
                :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)"
                :label-position="'top'"
                @submit.prevent="save('userForm', stepLanguage ? true : false)"
            >
                <el-form-item>
                    <el-checkbox-group v-model="formsData.userForm.languages.value">
                        <el-checkbox v-for="option in languages" :class="option.$isDisabled ? 'group' : ''" :disabled="option.$isDisabled" :label="option.desc" :key="option.title">
                            <template #default>
                                <span
                                    :class="'flag-icon flag-icon-' + option.flag"
                                ></span>
                                <span>{{option.title}}</span>
                            </template>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div class="language-fixed-button">
                <el-button
                    class="submit submit_button mb0"
                    type="blue"
                    @click="save('userForm', true)"
                    :disabled="formsData.userForm.disabled"
                >
                    <span v-if="routeName == 'profile_languages'">Save</span>
                    <span v-else>Continue</span>
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>

import { onMounted, inject, ref } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import PageTitle from "@/components/PageTitle/PageTitle.vue";

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        PageTitle,
    },
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);

        const routeName = $route.name;

        const userData = $store.getters.GET_USER_DATA;

        const languages = ref([]);
        const languagesList = $store.getters.getLanguagesList;

        Object.keys(languagesList).forEach((key) => {
            const language = {
                title: languagesList[key],
                desc: key,
                flag: key.split("_")[1] ? key.split("_")[1].toLowerCase() : false,
                show: true,
                $isDisabled: key.split("_")[1] ? false : true,
            };

            languages.value.push(language);
        });


        const formsDataArray = {
            userForm: {
                languages: {
                    value: userData.languages || [],
                    selectValue: [],
                    options: [],
                    remove: [false],
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "languages",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };


        const nextStep = () => {
            checkFormValidation("userForm", false);
        };

        const goBack = async() => {
            if (routeName == "profile_languages") {
                $router.push({
                    name: "profile_edit",
                });
            } else {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            }
        };

        const goNext = () => {
            if (routeName == "profile_languages") {
                $router.push({
                    name: "profile_edit",
                });
            } else {
                $router.push({
                    name: "identity_document",
                });
            }
        };

        const skip = () => {
            $store.dispatch("addAuthPageBack", $route.name);
            goNext();
        };

        const save = (formName, value) => {
            formsRefs[formName].value.validate((valid) => {

                if (valid) {
                    (async () => {
                        try {
                            console.log(getFormValues(formName));
                            const data = value
                                ? getFormValues(formName)
                                : {
                                    languages: null,
                                };
                            await $store.dispatch("SAVE_USER_DATA", data);
                            goNext();
                        } catch (error) {
                            console.log("error submit!!");
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log("error submit!!");
                    return false;
                }
            });
        };

        onMounted(() => {
            setPageClassGlobal("global_auth_page global_user_languages_page");
            setFormRefs();
        });

        const {
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        console.log({
            label: 'LanguageList',
            value: languages 
        });
        return {
            formsData,
            goBack,
            save,
            skip,
            nextStep,
            routeName,
            languages
        };
    },
};
</script>
